import FilterAltIcon from '@mui/icons-material/FilterAlt'
import SearchIcon from '@mui/icons-material/Search'
import { Button, Grid, TextField, Toolbar } from '@mui/material'
import { useCallback, useEffect, useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditDashboardFilters } from '../../data/types/CreditDashboardEntry'
import MainActions from './MainActions'
import SearchFilter from './SearchFilters'

interface Props {
  filterValues: CreditDashboardFilters
  resetFilter: () => void
  applyFilter: (data: CreditDashboardFilters) => void
  addDays: (date: Date, days: number) => Date
}

const DataGridHeader = ({ filterValues, resetFilter: resetFilters, applyFilter, addDays }: Props): JSX.Element => {
  const { t } = useTranslation()

  const [contains, setContains] = useState<string>(filterValues.contains)
  const [openSearchFilters, setOpenSearchFilters] = useState<boolean>(false)

  const onCancel = useCallback(() => {
    setOpenSearchFilters(false)
  }, [setOpenSearchFilters])

  useEffect(() => {
    setContains(filterValues.contains)
  }, [filterValues])

  const onApplyFilters = () => {
    applyFilter({
      ...filterValues,
      contains,
    })
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onApplyFilters()
      }}
    >
      <Toolbar disableGutters sx={{ m: 3 }}>
        <Grid container columnSpacing={2} flexGrow={1}>
          <Grid sx={{ mt: 1 }}>
            <MainActions />
          </Grid>
          <Grid
            size={{
              md: 3,
            }}
          >
            <TextField
              label={t('browseCreditApplications.dataGridHeader.appClientName')}
              onChange={(e) => setContains(e.target.value)}
              value={contains}
              fullWidth
              helperText={t('browseCreditApplications.dataGridHeader.searchHelperText')}
            />
          </Grid>
          <Grid
            size={{
              md: 3,
            }}
          >
            <Button type="submit" size="large">
              <SearchIcon fontSize="large" color="action" />
            </Button>
            <Button
              size="large"
              variant="contained"
              onClick={() => {
                setOpenSearchFilters(true)
              }}
            >
              <FilterAltIcon fontSize="medium" sx={{ color: 'white' }} />
            </Button>
          </Grid>
          {openSearchFilters ? (
            <SearchFilter
              open={openSearchFilters}
              filterValues={filterValues}
              resetFilter={resetFilters}
              applyFilter={applyFilter}
              addDays={addDays}
              onCancel={onCancel}
            />
          ) : null}
        </Grid>
      </Toolbar>
    </form>
  )
}

export default DataGridHeader
